const Routes = {
    dashboard: 'dashboard',
    inventory: 'inventory',
    login: 'login',
    password_email: 'passwordEmail',
    password_reset: 'passwordReset',
    deal: 'deal',
    company: 'company',
    create_company: 'createCompany',
    view_company: 'viewCompany',
    company_users: 'companyUsers',
    create_deal: 'createDeal',
    vehicle: 'vehicle',
    vehicle_shortlist: 'vehicleShortlist',
    view_vehicle: 'viewVehicle',
    create_vehicle: 'createVehicle',
    edit_vehicle: 'editVehicle',
    message: 'message',
    profile: 'profile',
    settings: 'settings',
    user: 'user',
    create_user: 'createUser',
    view_user: 'viewUser',
    view_vehicle_share: 'viewVehicleShare',
    customer_enquiry: 'customerEnquiry',
};

export default Routes
